var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VAppBar',{attrs:{"app":"","color":"teal"}},[_c('RouterLink',{staticClass:"logo",attrs:{"to":{ name: 'index' }},domProps:{"textContent":_vm._s('Единый Банковский Центр')}}),_c('VAppBarNavIcon',{staticClass:"white--text",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', !_vm.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }